import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  disabled: "",
  class: "reset-btn-disabled"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "modal"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = {
  key: 5,
  class: "modal"
}
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 6 }
const _hoisted_19 = { class: "calculation-reports-table" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[45] || (_cache[45] = _createElementVNode("h1", null, "Информация о директоре ДО", -1)),
    (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.managerRoles]) && _ctx.kindergartenHead)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "reset-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetPassword(_ctx.kindergartenHead.userInfo?.id)))
              }, "Сбросить пароль"))
            : (_openBlock(), _createElementBlock("button", _hoisted_1, "Загрузка..."))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.kindergartenHead)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[41] || (_cache[41] = _createElementVNode("h2", null, "Информация о пользователе", -1)),
          _createElementVNode("p", null, [
            _cache[13] || (_cache[13] = _createElementVNode("strong", null, "ID пользователя:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.userInfo.id), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Имя:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.userInfo.firstName), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Фамилия:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.userInfo.lastName), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Имя пользователя:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.userInfo.username), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[17] || (_cache[17] = _createElementVNode("strong", null, "ИИН:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.userInfo.userAttributes[_ctx.UserAttribute.IIN]), 1)
          ]),
          (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.managerRoles]))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-warning",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openEditKindergartenHead && _ctx.openEditKindergartenHead(...args)))
              }, "Внести изменение в Директора ДО"))
            : _createCommentVNode("", true),
          (_ctx.showEditKindergartenHead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[22] || (_cache[22] = _createElementVNode("h2", null, "Добавить директора ДО", -1)),
                  _createElementVNode("form", {
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmitUpdateKindergartenHead && _ctx.handleSubmitUpdateKindergartenHead(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { for: "firstName" }, "Имя:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "firstName",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.firstName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { for: "lastName" }, "Фамилия:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "lastName",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.lastName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { for: "iin" }, "ИИН:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "iin",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.iin) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.iin]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { for: "lmsId" }, "LMS система:", -1)),
                      _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedLms,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLms) = $event)),
                        options: _ctx.lmsSystems,
                        label: "lmsId",
                        placeholder: "Выберите LMS систему",
                        searchable: true,
                        "clear-on-select": true,
                        "close-on-select": true,
                        "allow-empty": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "submit-btn",
                      disabled: _ctx.isLoading
                    }, _toDisplayString(_ctx.isLoading ? 'Сохранение...' : 'Сохранить'), 9, _hoisted_9)
                  ], 32),
                  _createElementVNode("button", {
                    class: "close-modal-btn",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Закрыть")
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[42] || (_cache[42] = _createElementVNode("h2", null, "Информация о LMS системе", -1)),
          _createElementVNode("p", null, [
            _cache[23] || (_cache[23] = _createElementVNode("strong", null, "ID LMS:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.lmsId), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[24] || (_cache[24] = _createElementVNode("strong", null, "Группа региона:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.regionGroup?.code), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[25] || (_cache[25] = _createElementVNode("strong", null, "Тип населенного пункта:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.localityType?.name), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Населенный пункт:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.kato?.nameRu), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Физический адрес:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.address), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Номер договора и дата:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.contractNumberAndDate), 1)
          ]),
          _cache[43] || (_cache[43] = _createElementVNode("h2", null, "Информация о ДО", -1)),
          (_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _cache[29] || (_cache[29] = _createElementVNode("strong", null, "БИН ДО:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo.bin), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Наименование ДО:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Тип собственности:", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo.ownershipType?.name), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "open-modal-btn",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
          }, "Выгрузить расчет"),
          (_ctx.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Выберите месяц и год", -1)),
                  _createElementVNode("form", {
                    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { for: "accountingMonth" }, "Месяц:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        id: "accountingMonth",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accountingMonth) = $event)),
                        min: "1",
                        max: "12",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.accountingMonth]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", { for: "accountingYear" }, "Год:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        id: "accountingYear",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.accountingYear) = $event)),
                        min: "2000",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.accountingYear]
                      ])
                    ]),
                    _createElementVNode("p", null, [
                      _cache[34] || (_cache[34] = _createElementVNode("strong", null, "БИН:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem.kindergartenDocumentInfo?.bin), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _cache[35] || (_cache[35] = _createElementVNode("strong", null, "ID LMS:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.kindergartenHead.lmsSystem?.lmsId), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "submit-btn",
                      disabled: _ctx.isLoading
                    }, _toDisplayString(_ctx.isLoading ? 'Выгружается...' : 'Выгрузить'), 9, _hoisted_17)
                  ], 32),
                  _createElementVNode("button", {
                    class: "close-modal-btn",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Закрыть")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.calculationReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[40] || (_cache[40] = _createElementVNode("h2", null, "Отчеты о расчетах", -1)),
                _createElementVNode("table", _hoisted_19, [
                  _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "ID"),
                      _createElementVNode("th", null, "Не подписанный расчет"),
                      _createElementVNode("th", null, "Расчетный месяц"),
                      _createElementVNode("th", null, "Расчетный год"),
                      _createElementVNode("th", null, "Статус")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedReports, (calculationReport) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: calculationReport.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(calculationReport.id), 1),
                        _createElementVNode("td", null, [
                          (calculationReport.report.reportStatus==='GENERATING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(calculationReport.report.fileName ?? 'N/A'), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: ($event: any) => (_ctx.handleDownload(calculationReport.report.uuid, calculationReport.report.fileName)),
                                class: _normalizeClass({ 'active-link': calculationReport.report?.reportStatus === 'GENERATED', 'error-link': calculationReport.report?.reportStatus === 'ERROR' })
                              }, _toDisplayString(calculationReport.report.fileName ?? 'N/A'), 11, _hoisted_21))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(calculationReport.accountingMonth), 1),
                        _createElementVNode("td", null, _toDisplayString(calculationReport.accountingYear), 1),
                        _createElementVNode("td", null, [
                          (calculationReport.report?.reportStatus==='ERROR')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Неизвестная ошибка"))
                            : _createCommentVNode("", true),
                          (calculationReport.report?.reportStatus==='GENERATING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Выгружается"))
                            : (calculationReport.signStatus === 'SIGNED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Подписан"))
                              : (calculationReport.signStatus === 'NOT_SIGNED')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Не подписан"))
                                : (calculationReport.signStatus === 'REJECTED_BY_HEAD')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "reject-status" }, "Отказано от Директора ДО", -1)),
                                      _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(calculationReport.rejectComment), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[44] || (_cache[44] = [
            _createElementVNode("p", null, "Загрузка информации...", -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("p", null, "Ошибка при загрузке информации: " + _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true)
  ]))
}